import { TextareaAutosizeProps } from "react-textarea-autosize";

import { Container } from "./styled";
export { Container as TextareaContainer };

export interface TextareaProps extends TextareaAutosizeProps {
  /** Callback function executes when value of input changes.  */
  onValueChange: (value: string) => void;
}

/** You probably don't want to use this directly */
export const Textarea = ({
  onValueChange,
  onChange,
  rows = 1,
  ...props
}: TextareaProps) => {
  function handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    if (onChange) onChange(event);
    onValueChange(event.target.value);
  }

  return (
    <Container
      {...props}
      onChange={handleChange}
      minRows={1}
      maxRows={5}
      style={{ height: 42 }}
    />
  );
};
